// extracted by mini-css-extract-plugin
module.exports = {"image":"cL","image-placeholder":"cM","imagePlaceholder":"cM"};